module.exports = __webpack_public_path__ + "img/nevsCardTitBlue.d20c281f.png";